export default __webpack_public_path__ + "static/media/ic-close-factor.260b7f6b.svg";